<template>
    <div class="field-group">
        <label v-for="year in years" :key="year.value">
            <input type="checkbox" :value="year.value" :checked="isChecked(year.value)" @change.prevent="update(year.value)">
            <span>{{year.title}}</span>
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: []
            },
            years: {
                type: Array,
                default(total = 5) {
                    let currentYear = new Date().getFullYear();
                    
                    const readyYear = {
                        title: "Сдан",
                        value: 0
                    };

                    let years = [];
                    years.push(readyYear);
                    for (let i = currentYear; years.length < total; i++) {
                        years.push({
                            title: i,
                            value: i
                        });
                    }
                    return years;
                }
            }
        },
        data() {
            return{
                yearsSelected: this.value
            }       
        },
        methods: {
            update(value) {
                if (!this.yearsSelected.includes(value)) {
                    this.yearsSelected.push(value);
                }
                else {
                    this.yearsSelected.splice(this.yearsSelected.indexOf(value), 1);
                }
            },
            isChecked(value) {
                return this.yearsSelected.includes(value);
            }
        },
        watch: {
            yearsSelected() {
                this.$emit('input', this.yearsSelected);
            }
        }
    }
</script>